// @module C3.ShoppingExtensions.InventoryList
define('C3.ShoppingExtensions.CartPage.SavedForLaterCustom'
,	[
	     'c3_shoppingextensions_cartpage_savedforlatercustom.tpl',
		 'Utils',
		 'Profile.Model',
		 'LiveOrder.Model',
		 'C3.ShoppingExtensions.LoginRegister.View', 
		 'C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.View',
		 'Product.Model',
		 'ProductList.DetailsLater.View',
		 'ProductList.Model',
		 'jQuery.sidebarPDPWishListMenu'
    ]
, function (
	    c3_shoppingextensions_cartpage_savedforlatercustom_tpl,
		Utils,
		ProfileModel,
		LiveOrderModel,
		LoginRegisterView,
		ProductListControlView,
		ProductModel,
		ProductListDetailsLaterView,
		ProductListModel
)
{
    'use strict';

	// @class C3.ShoppingExtensions.InventoryList.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_cartpage_savedforlatercustom_tpl

	,	initialize: function (options) {
			this.application = options.application;
	        this.model = options.model;


	        this.countedClicks = {};

            const self = this;

            this.first_time_render = true;

	        this.utils =
                this.application.ProductListModule && this.application.ProductListModule.Utils;
            this.collection = this.utils.getProductLists();

            ProfileModel.getPromise().done(function() {
                self.loaded_site_settings = true;
                self.render();
            });
		}


	, 	childViews: {
			'SavedForLaterWishList': function ()
	            {
	            	var pll = this.productListList
	            	,   requiredPL = []

	            	//console.log(pll)
	                pll.each(function(model) {
	                	if(model.get('typeId') == "3")     
	                	requiredPL = model           
	                });
	                //console.log(requiredPL)

	                if (this.utils && this.utils.isProductListEnabled()) {
		                return new ProductListDetailsLaterView({
		                    application: this.options.application,
		                    model: requiredPL,
		                    targetListId : requiredPL.get('internalid')
		                });
		            }	            

		            return null;
	            }
		}



	,   render: function() {
            if (this.loaded_site_settings && this.utils && this.utils.isProductListEnabled()) {
                if (this.first_time_render) {
                    this.utils.getProductListsPromise().done(_.bind(this.render, this));
                    this.first_time_render = false;
                    this.productListList = this.utils.getProductLists()
                    return this.$el.empty();
                }
            } else {
                return this.$el.empty();
            }

            this._render();
        }	

		//@method getContext @return C3.ShoppingExtensions.InventoryList.View.Context
	,	getContext: function getContext()
		{
			//console.log(this)
			return {

	            isLoading: this.utils.getProductListsPromise().state() === 'pending'
			};
		}
	});
});
